import { Box, Stack, styled } from '@mui/material';
import { Link } from 'react-router-dom';

export const EditLayout = styled(Stack)(({ theme }) => ({
  gap: 0,
  paddingBottom: theme.spacing(3),
  '& > :first-of-type': {
    marginBottom: theme.spacing(1),
  },
}));

export const Form = styled('form')({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
});

export const BreadcrumbLink = styled(Link)(({ theme }) => ({
  color: theme.palette.text.primary,
  textDecoration: 'none',
  '&:hover': { textDecoration: 'underline' },
}));

export const SectionsCard = styled(Box)(({ theme }) => ({
  background: theme.palette.common.white,
  border: `1px solid ${theme.palette.grey.A400}`,
  borderRadius: 8,
  '& .MuiOutlinedInput-root.MuiInputBase-sizeSmall:not(.MuiInputBase-multiline)':
    {
      '& .MuiOutlinedInput-input': {
        paddingTop: 6,
        paddingBottom: 6,
        height: 20,
      },
      '& .MuiSelect-select.MuiSelect-outlined': {
        paddingTop: 6,
        paddingBottom: 6,
        minHeight: 20,
        height: 20,
        boxSizing: 'content-box',
        display: 'flex',
        alignItems: 'center',
      },
    },
}));
